import React, { memo } from 'react';
import { useObservable } from 'react-use-observable';

import { Button } from 'antd';

import { Field, useFormikContext } from 'formik';
import { FilterActions } from 'v2/components/Shared/FilterActions';
import { DateRangePickerFormField } from 'v2/components/Shared/FormFields/DateRangePicker';
import { SelectFormField } from 'v2/components/Shared/FormFields/SelectFormField';
import { SelectProduct } from 'v2/components/Shared/FormFields/SelectProduct';
import { TextFormField } from 'v2/components/Shared/FormFields/TextFormField';
import type { IFilter } from 'v2/interfaces/affiliate';
import affiliateService, { getInitialFilter } from 'v2/services/affiliate';

import { Icon } from '@eduzz/ui-antd-theme';

const Basic = () => {
  const [isLoading] = useObservable(() => affiliateService.isLoading(), []);

  const { values, setFieldValue, isSubmitting, isValid, setErrors, dirty, resetForm } = useFormikContext<IFilter>();

  const onChangeAffiliateType = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFieldValue('affiliate_type', e.target.value);
    setFieldValue('affiliate_value', '');
    setErrors({});
  };

  const handleClearFilter = () => {
    const clearedValues = getInitialFilter();
    resetForm({ values: clearedValues });
    affiliateService.cleanFilter();
  };

  const AffiliatesTypeOptions = [
    { label: 'Nome', value: 'affiliate_name' },
    { label: 'E-mail', value: 'affiliate_email' }
  ];

  const StatusOptions = [
    { label: 'Pendente', value: 'pending' },
    { label: 'Aprovado', value: 'approved' },
    { label: 'Reprovado', value: 'reproved' }
  ];

  const isCleanDisabled = !dirty || isSubmitting || isLoading;
  const isFilterDisabled = !isValid || isSubmitting || isLoading;

  return (
    <div className='grid grid-cols-1 items-end gap-3 sm:grid-cols-2 lg:grid-cols-3'>
      <div>
        <Field isPresetLonger label='Data da solicitação' id='date' name='date' component={DateRangePickerFormField} />
      </div>
      <div>
        <Field
          id='affiliate_type'
          name='affiliate_type'
          label='Afiliado'
          fullWidth
          options={AffiliatesTypeOptions}
          component={SelectFormField}
          onChange={onChangeAffiliateType}
        />
      </div>
      <div>
        <Field
          id='affiliate_value'
          name='affiliate_value'
          type={values.affiliate_type === 'affiliate_email' ? 'email' : 'text'}
          label={values.affiliate_type === 'affiliate_email' ? 'E-mail' : 'Nome'}
          placeholder={values.affiliate_type === 'affiliate_email' ? 'Digite o e-mail' : 'Digite o nome'}
          component={TextFormField}
          fullWidth
        />
      </div>
      <div>
        <Field
          id='product_id'
          name='product_id'
          fullWidth
          label='Produtos'
          endpoint='/affiliates/filter/products'
          component={SelectProduct}
        />
      </div>
      <div>
        <Field id='status' name='status' label='Status' fullWidth options={StatusOptions} component={SelectFormField} />
      </div>
      <div>
        <FilterActions>
          <Button
            id='clear-button'
            type='text'
            loading={isLoading || isSubmitting}
            disabled={isCleanDisabled}
            onClick={handleClearFilter}
          >
            Limpar
          </Button>
          <Button
            type='primary'
            icon={<Icon.Funnel />}
            disabled={isFilterDisabled}
            htmlType='submit'
            loading={isLoading || isSubmitting}
          >
            Filtrar
          </Button>
        </FilterActions>
      </div>
    </div>
  );
};

export default memo(Basic);
